exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mailEditor {\n  background: #fff;\n  padding: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/views/FastRunnerTableView.vue?vue&type=style&index=0&id=5b34e47d&lang=stylus&
// module id = 560
// module chunks = 2